var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { Legend } from '@guardian/src-label';
import { InlineError } from '@guardian/src-user-feedback';
import { descriptionId, generateSourceId, } from '@guardian/src-foundations/accessibility';
import { fieldset, horizontal, vertical } from './styles';
const orientationStyles = {
    vertical: vertical,
    horizontal: horizontal,
};
/**
 * [Storybook](https://guardian.github.io/source/?path=/docs/source-src-radio-radio-group--demo) •
 * [Design System](https://theguardian.design/2a1e5182b/p/2891dd-radio-button/b/46940d) •
 * [GitHub](https://github.com/guardian/source/tree/main/src/core/components/radio) •
 * [NPM](https://www.npmjs.com/package/@guardian/src-radio)
 *
 * Radio buttons allow users to make a single selection from a set of options.
 *
 * The following themes are supported: `default`, `brand`
 */
export const RadioGroup = (_a) => {
    var { id, name, label, hideLabel = false, supporting, orientation = 'vertical', error, cssOverrides, children } = _a, props = __rest(_a, ["id", "name", "label", "hideLabel", "supporting", "orientation", "error", "cssOverrides", "children"]);
    const groupId = id || generateSourceId();
    const legend = label ? (_jsx(Legend, { text: label, supporting: supporting, hideLabel: hideLabel }, void 0)) : ('');
    const message = error && (_jsx(InlineError, Object.assign({ id: descriptionId(groupId) }, { children: error }), void 0));
    return (_jsxs("fieldset", Object.assign({ "aria-invalid": !!error, id: groupId, css: (theme) => [
            fieldset(theme.radio && theme),
            orientationStyles[orientation],
            cssOverrides,
        ] }, props, { children: [legend, message, React.Children.map(children, (child) => {
                return React.cloneElement(child, Object.assign(error
                    ? {
                        'aria-describedby': descriptionId(groupId),
                    }
                    : {}, {
                    name,
                }));
            })] }), void 0));
};
//# sourceMappingURL=RadioGroup.js.map
